

if(!customElements.get('accordion-component')) {
  customElements.define('accordion-component', 
    class Accordion extends HTMLElement {
      constructor() {
        super();
        this.accordionBody = this.querySelector('[data-body]');
        this.accordionButton = this.querySelector('[data-button]');
        this.buttonIcon = this.querySelector('[data-icon]');
      }

      get open() {
        return this.dataset.open === 'true'
      }

      connectedCallback() {
        this.init();
      }

      init() {
        if(!this.accordionButton && !this.accordionBody) return;
        const height = this.accordionBody?.firstElementChild?.clientHeight;
        if(!height) return;
        this.setInitialState(height);
        this.accordionButton.addEventListener('click', ()=> this.toggleAccordion(height));
      }

      toggleAccordion(height) {
        this.dataset.open = !this.open;
        this.open ? this.handleOpen(height) : this.handleClose();
      }

      handleOpen(height) {
        this.accordionBody.style.height = `${height}px`;
        this.accordionButton.setAttribute('aria-expanded', true);
        if(!this.buttonIcon) return;
        this.buttonIcon.classList.replace('rotate-90', '-rotate-90');
      }

      handleClose() {
        this.accordionBody.style.height = `0px`;
        this.accordionButton.setAttribute('aria-expanded', false);
        if(!this.buttonIcon) return;
        this.buttonIcon.classList.replace('-rotate-90', 'rotate-90');
      }

      setInitialState(height) {
        this.accordionBody.style.cssText = 'transition: height 0.15s ease-in-out; height: 0px;'
        if(!this.open) return;
        this.accordionBody.style.height = `${height}px`;
      }
    }
  )
}